import { render } from "./EventSmallBox.vue?vue&type=template&id=31ac42b2&scoped=true"
import script from "./EventSmallBox.vue?vue&type=script&lang=js"
export * from "./EventSmallBox.vue?vue&type=script&lang=js"

import "./EventSmallBox.vue?vue&type=style&index=0&id=31ac42b2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ac42b2"]])

export default __exports__